'use strict';

angular.module('shiftTraderApp.filters', [])
  .filter('acceptance_word', function () {
    return function (input) {
      if (angular.isNumber(input)) {
        switch (input) {
          case 10:
            return 'ACCEPTED';
          case 11:
            return 'REJECTED';
          case 0:
            return 'IN PROGRESS';
          case 20:
            return 'APPROVED';
          case 21:
            return 'DISAPPROVED';
          case 40:
            return 'CANCELLED';
        }
        return '';
      }
    };
  })
  .filter('filterByIdMismatch',function () {
    //Return every entry except the one which matches the id
    return function (obj, id) {
      return _.filter(obj, function (entry) {
        return (entry.id !== id);
      });
    };
  }).
  filter('filterByUserIdMismatch',function () {
    //Return every entry except the one which matches the id
    return function (objs, userId) {
      return _.filter(objs, function (entry) {
        return (entry.user.id !== userId);
      });
    };
  }).
  filter('onlyPosition',function () {
    //Return work periods which correspond to a particular position_id or parent.position_id
    return function (workPeriods, position) {
      return _.filter(workPeriods, function (workPeriod) {
        if (angular.isUndefined(workPeriod)) {
          return false;
        }
        if (angular.equals(workPeriod.position.id, position.id)) {
          return true;
        }
        return angular.isDefined(workPeriod.position.parent) && angular.equals(workPeriod.position.parent.id, position.id);
      });
    };
  }).
  filter('onlyUsersWithPositionId', function () {
    return function (users, position_id) {
      if (_.isUndefined(position_id)) {
        return users;
      }
      else {
        var data = _.filter(users, function (usr) {
          return _.any(usr.users_positions, function (up) {
            return up.position_id === position_id;
          });
        });
        return data;
      }
    };
  }).
  filter('onlyUsersWithPositionIdAndNotScheduledAndActive', function () {
    return function (users, position_id) {
      if (_.isUndefined(position_id)) {
        return users;
      }
      else {
        var data = _.filter(users, function (usr) {
          if (!usr.scheduledToWork) {
            return _.any(usr.users_positions, function (up) {
              return up.position_id === position_id;
            }) && usr.memberships[0].active === 1;
          } else {
            return false;
          }
        }, this);
        return data;
      }
    };
  })
  .filter('abbreviatedName', function () {
    //Shortens Matt Webb to "Matt W."
    //No handling for three part names
    return function (name) {
      if (lodash.isNil(name)) {
        return '';
      } else {
        var split_name = name.split(' ');
        return (split_name[0] + ' ' + split_name[1][0] + '.') ;
      }
    };
  })
  .filter('capitalize', function () {
    //"word two" to "Word Two"
    return function (text) {
      var proc_text = _.map(text.split(' '), function(word) {
        return word.charAt(0).toUpperCase() + word.slice(1);
      });
      return proc_text.join(' ');
    };
  })
  .filter('toLocalTime', ['Session', function(Session) {
    return function(mmnt) {
      return mmnt.tz(Session.getTimezone());
    };
  }])
  .filter('localTimeFmt', ['Session', function(Session) {
    return function(mmnt, fmt) {
      return moment(mmnt).tz(Session.getTimezone()).format(fmt);
    };
  }])
  .filter('minimalMomentFormat', ['TimeService', function(TimeService) {
    return function(mmnt, showMeridian) {
      return TimeService.minimalMomentFormat(mmnt, showMeridian);
    };
  }])
  .filter('minimalTwixFormat', ['TimeService', function(TimeService) {
    return function(twix, showMeridian) {
      return TimeService.minimalTwixFormat(twix, showMeridian);
    };
  }])
  .filter('publishedShifts', function() {
    return function(shifts) {
      if (shifts.length > 0) {
        return _.where(shifts, function(shift) {
          return (!_.isNull(shift.published_by_id) && _.isUndefined(shift.published_by)) || (!_.isNull(shift.published_by) && _.isUndefined(shift.published_by_id))
            || (shift.published_by_id && shift.published_by);
        });
      } else {
        return [];
      }
    };
  })
  .filter('orderByManagerTradesPriority', function() {
    return function(trades, active) {
      if (trades.length > 0) {
        //Sort by accepted or waiting first, prioritizing shift trades on the most recent shifts first,
        // then the trade that is occurring the earliest in time
        var curSort = _.sortBy(trades, function(trade) {
          if (trade.$isGiveaway) {
            return trade.work_period.start_time.unix();
          } else {
            // earlier of the two, either work_period or trade_work_period for a one-to-one trade
            return Math.min([trade.work_period.start_time.unix(), trade.trade_work_period.start_time.unix()]);
          }
        });
        if (active === 'true') {
          return _.sortBy(curSort, function(trade) {
            return -1*trade.$currentStatus();
          });
        } else {
          // if using the inactive manageTrades view then trades should be sorted by work_periods.start_time most recent first
          return curSort.reverse();
        }
      } else {
        return [];
      }
    };
  })
  .filter('dayNumberToWords', function() {
    return function(dayNum, short) {
      if (angular.isDefined(short)) {
        return ['Su', 'M', 'Tu', 'W', 'Th', 'F','Sa'][dayNum];
      } else {
        return ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][dayNum];
      }
    };
  })
  .filter('stripCharacters', function() {
    return function(string, numChars) {
      if (!numChars) {
        numChars = 1;
      }

      if (!_.isNull(string) && !_.isUndefined(string)) {
        return string.slice(0, -1 * numChars);
      } else {
        return string;
      }
    }
  })
  .filter('mathCeil', function() {
    return function(number) {
      return Math.ceil(number);
    };
  })
  .filter('activeApprovedBlackoutRules', function () {
    //Return every entry except the one which matches the id
    return function (objs) {
      return _.filter(objs, function (entry) {
        return (entry.active && !_.isNull(entry.approved_by) && entry._type === 'single');
      });
    };
  })
  .filter('activeUnapprovedBlackoutRules', function () {
    //Return every entry except the one which matches the id
    return function (objs) {
      return _.filter(objs, function (entry) {
        return (entry.active && _.isNull(entry.approved_by) && entry._type === 'single');
      });
    };
  })
  .filter('disapprovedBlackoutRules', function () {
    //Return every entry except the one which matches the id
    return function (objs) {
      return _.filter(objs, function (entry) {
        return (!entry.active && !_.isNull(entry.approved_by) && entry._type === 'single');
      });
    };
  })
  .filter('ordinalSuffix', function() {
    function getOrdinal(n) {
      var s = ["th","st","nd","rd"],
        v = n % 100;
      return (s[(v - 20) % 10] || s[v] || s[0]);
    }

    return function(num) {
      return (_.isUndefined(num) || _.isNull(num)) ? '' : getOrdinal(num);
    }
  });
